import React from 'react';
import { ScrollView, StyleSheet, View, Dimensions } from './base_components';
import Header from './header';
import LeftNav from './left_nav';

const styles = StyleSheet.create({
  standardScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'row',
  },
  right: {
    flex: 1,
    alignSelf: 'stretch',
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    backgroundColor: '#e5e5e5',
  },
  scrollerInner: {
    flexDirection: 'column',
  },
});

type Props = {
  style?: any;
  children: any;
};
export default function StandardScreen(props: Props) {
  const [is_closed, setClosed] = React.useState(
    window.localStorage.LEFT_CLOSED === 'true'
  );
  const [is_open, setOpen] = React.useState(false);

  function _onClose() {
    setOpen(false);
    setClosed(true);
    window.localStorage.LEFT_CLOSED = true;
  }
  function _onMenu() {
    const { width } = Dimensions.get();
    const is_small = width < 600;
    const auto_closed = !is_open && is_small;
    const is_small_open = is_open && is_small;
    if (is_small_open) {
      setOpen(false);
    } else if (auto_closed) {
      setOpen(true);
      setClosed(false);
    } else if (is_closed && is_small) {
      setOpen(true);
      setClosed(false);
      window.localStorage.LEFT_CLOSED = false;
    } else if (is_closed) {
      setClosed(false);
      window.localStorage.LEFT_CLOSED = false;
    } else {
      _onClose();
    }
  }

  return (
    <View style={[styles.standardScreen, props.style]}>
      <Header closed={is_closed} onMenu={_onMenu} />
      <View style={styles.body}>
        <LeftNav open={is_open} closed={is_closed} onClose={_onClose} />
        <View style={styles.right}>
          <ScrollView
            style={styles.scroller}
            contentContainerStyle={styles.scrollerInner}
          >
            {props.children}
          </ScrollView>
        </View>
      </View>
    </View>
  );
}
